/* eslint-disable no-shadow */
// clippyNotifications
import { EventBus } from '../components/EventBus';

const moment = require('moment-timezone');

const state = {
    items: [],
};

const defaultMessages = {
    ADD_UNIVERSITY: {
        message: 'Aquí podrás saber qué instituciones imparten cada carrera, dale una mirada, podrás compararlas según su ubicación, costo total y duración.',
    },
    OPEN_FAVORITES: {
        title: 'Hint:',
        message: 'Estas son las carreras que te han interesado. <p style="color: #37D4F3"><strong>Haz tu ranking según la que más te interesa.</strong></p> También puedes eliminar las que no te interesan tanto o volver al explorador',
    },
    AFTER_XTIME_SAME_CAREER: {
        message: 'Quieres mirar otra carrera?, a tu derecha hay otras opciones que te podrían interesar de acuerdo a tu perfil. ¡O selecciona la opción de nuevas recomendaciones!',
        timer: 180,
    },
    AFTER_XTIME_VISIT_FAVORITES: {
        message: '¡Recuerda poner como primera de la lista tu carrera preferida para crear un plan ordenado!',
        timer: 40,
    },
    MORE_THAN_X_SELECTED_CAREERS: {
        message: 'Tienes muchas opciones, piensa en qué es lo que más te importa y elimina a las que no te gustaría asistir',
    },
    NOT_ADD_UNIVERSITY_IN_XTIME: {
        message: 'Recuerda buscar dónde puedes estudiar cada una de las carreras que te gustan en “Agregar Universidad”',
        timer: 45,
    },
    NOT_SELECT_UNIVERSITY_IN_XTIME: {
        message: 'En esta sección puedes seleccionar la o las universidades en que te gustaría estudiar esta carrera',
        timer: 30,
    },
    UPDATE_RANKING: {
        message: 'Comparte esta información con tu familia y amigos, ellos te pueden ayudar a tomar una decisión y apoyarte en este proceso. Puedes descargarla o enviarla a tu correo electrónico',
    },
    VISIT_X_CAREERS: {
        message: 'Cuando hayas terminado de explorar, puedes comparar tus carreras favoritas y buscar dónde estudiarlas en “Mis Favoritos”',
    },
    VISIT_FAVORITE_LESS_X_CAREERS_VISITED: {
        message: '¿Segura/o que no quieres seguir explorando? ¡Puedes encontrar otras carreras interesantes!',
    },
    VISIT_FAVORITE_LESS_X_CAREERS_FAVORITES: {
        message: '¿Te gustaría incorporar más carreras?, Puede que todavía no hayas visto la carrera para ti',
    },
    ADD_MORE_THAN_X_FAVORITE: {
        message: 'Felicitaciones! Ya has seleccionado bastantes posibles carreras. ¿Quieres compararlas?. Entra a <p style="color: #37D4F3"><strong>“Mis Favoritos”</strong></p>',
    },
    WATCH_UNIVERSITY_DETAILS: {
        message: 'Mira el detalle de esta institución. Puedes ver cómo le fue a los egresados en Pruebas Nacionales, el Pensum y su información de contacto.  Si quieres ver más detalle de cada una, entra a su página web',
    },
    WATCH_VIDEO: {
        message: 'Para entender mejor la información que entrega el gráfico haz click en el botón <p style="color: #37D4F3"><strong>"ver video"</strong></p>',
    },
    HAVING_RANKING: {
        message: 'Ahora que tienes tu ranking, te recomendamos Explorar y Agregar Universidades.',
    },
};

const counters = {
    VISITED_CAREERS: 0,
};

const visitedCarrers = [];

/* eslint-disable no-unused-vars */
const actions = {
    add({ commit }, { title, message }) {
        const item = {
            time: moment.now(),
            title,
            message,
        };
        commit('add', item);
    },
    addCounter(key) {
        counters[key] += 1;
    },
    addDirectMessage({ commit }, key) {
        const message = defaultMessages[key];
        const timeToLive = moment.now() + Math.round(Math.random() * 100) + 10000;
        if (message) {
            const item = {
                time: timeToLive,
                title: message.title || 'Hint:',
                message: message.message,
            };
            commit('add', item);
        }
    },
    /*
    To add timer a defaultMessage, the message must have 'timer' field.
    */
    addTimer({ commit }, key) {
        const message = defaultMessages[key];
        const time = message.timer ? message.timer * 1000 : 0; // time to ms

        if (message) {
            const timeoutID = window.setTimeout(() => {
                this.dispatch('clippyNotifications/addDirectMessage', key);
                if (key === 'AFTER_XTIME_VISIT_FAVORITES') {
                    EventBus.$emit('showOverlayRow');
                }
            }, time);
            message.timeout = timeoutID;
        }
    },
    cancelTimer({ commit }, key) {
        const timeoutId = defaultMessages[key] ? defaultMessages[key].timeout : null;
        if (timeoutId) {
            window.clearTimeout(timeoutId);
        }
    },
    inspectCounters() {
        const visitedCarrers = counters.VISITED_CAREERS;
        if (visitedCarrers === 5) {
            this.dispatch('clippyNotifications/addDirectMessage', 'VISIT_X_CAREERS');
        }
    },
    remove({ commit }, time) {
        commit('delete', time);
    },
    /*
    Actions from page
    */
    addUniversity(university) {
        this.dispatch('clippyNotifications/addTimer', 'NOT_SELECT_UNIVERSITY_IN_XTIME');
        this.dispatch('clippyNotifications/cancelTimer', 'NOT_ADD_UNIVERSITY_IN_XTIME');
    },
    addVisitCareer(career) {
        this.dispatch('clippyNotifications/addTimer', 'AFTER_XTIME_SAME_CAREER');
        if (visitedCarrers.indexOf(career) < 0) {
            visitedCarrers.push(career);
            counters.VISITED_CAREERS += 1;
            this.dispatch('clippyNotifications/inspectCounters');
        }
    },
    clearAll({ commit }) {
        commit('deleteAll');
    },
    leaveCareer(career) {
        this.dispatch('clippyNotifications/cancelTimer', 'AFTER_XTIME_SAME_CAREER');
    },
    leaveFavorites() {
        this.dispatch('clippyNotifications/cancelTimer', 'AFTER_XTIME_VISIT_FAVORITES');
    },
    selectUniversity({ commit }, universityId = 0) {
        // addUniversity > select one
        this.dispatch('clippyNotifications/cancelTimer', 'NOT_SELECT_UNIVERSITY_IN_XTIME');
    },
    visitFavorites({ commit }, favoritesLength) {
        this.dispatch('clippyNotifications/addDirectMessage', 'OPEN_FAVORITES');
        EventBus.$emit('showOverlayRanking');
        this.dispatch('clippyNotifications/addDirectMessage', 'HAVING_RANKING');
        EventBus.$emit('showOverlayButton');
        this.dispatch('clippyNotifications/addTimer', 'AFTER_XTIME_VISIT_FAVORITES');
        this.dispatch('clippyNotifications/addTimer', 'NOT_ADD_UNIVERSITY_IN_XTIME');
        const visitedCarrers = counters.VISITED_CAREERS;
        if (visitedCarrers < 3) {
            this.dispatch('clippyNotifications/addDirectMessage', 'VISIT_FAVORITE_LESS_X_CAREERS_VISITED');
        }
        if (favoritesLength < 3) {
            this.dispatch('clippyNotifications/addDirectMessage', 'VISIT_FAVORITE_LESS_X_CAREERS_FAVORITES');
        }
    },
};
/* eslint-enable */

/* eslint-disable no-shadow */
const mutations = {
    add(state, message) {
        state.items.push(message);
    },
    delete(state, time) {
        state.items = state.items.filter((item) => {
            let difference = moment(item.time);
            if (item.message === defaultMessages.AFTER_XTIME_VISIT_FAVORITES.message) {
                EventBus.$emit('closeOverlayRow');
            }
            if (item.message === defaultMessages.HAVING_RANKING.message) {
                EventBus.$emit('closeOverlayButton');
            }
            if (item.message === defaultMessages.ADD_MORE_THAN_X_FAVORITE.message) {
                EventBus.$emit('closeOverlayFavourites');
            }
            if (item.message === defaultMessages.WATCH_VIDEO.message) {
                EventBus.$emit('closeOverlayVideo');
            }
            if (item.message === defaultMessages.OPEN_FAVORITES.message) {
                EventBus.$emit('closeOverlayRanking');
            }
            difference = difference.diff(moment(time));
            // add little margin of error
            if (difference === 0) {
                return false;
            }
            return true;
        });
    },
    deleteAll(state) {
        // Function that checks if an overlay must be closed or not.
        function checkOverlayMessages(items) {
            if (items.some(messages => messages.message === defaultMessages.AFTER_XTIME_VISIT_FAVORITES.message)) {
                EventBus.$emit('closeOverlayRow');
            }
            if (items.some(messages => messages.message === defaultMessages.HAVING_RANKING.message)) {
                EventBus.$emit('closeOverlayButton');
            }
            if (items.some(messages => messages.message === defaultMessages.ADD_MORE_THAN_X_FAVORITE.message)) {
                EventBus.$emit('closeOverlayFavourites');
            }
            if (items.some(messages => messages.message === defaultMessages.WATCH_VIDEO.message)) {
                EventBus.$emit('closeOverlayVideo');
            }
            if (items.some(messages => messages.message === defaultMessages.OPEN_FAVORITES.message)) {
                EventBus.$emit('closeOverlayRanking');
            }
        }

        checkOverlayMessages(state.items);
        state.items = [];
        // Clear all timeout msgs
        Object.values(defaultMessages).filter(msg => msg.timeout).forEach((msg_with_timeout) => {
            const timeoutId = msg_with_timeout.timeout;
            if (timeoutId) {
                window.clearTimeout(timeoutId);
            }
        });
    },
};
/* eslint-enable */

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
